import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LxlibUtilModule } from '@lxlib/util';
import { ImageDirective } from './image.directive';

const DIRECTIVES = [ImageDirective];

@NgModule({
  imports: [CommonModule, LxlibUtilModule],
  declarations: [...DIRECTIVES],
  exports: [...DIRECTIVES],
})
export class ImageModule {}
